import { Layout } from "antd"
import { ArabicLogoInDroidArabicKufi } from "components/svg"
import { Button, Flex, Icon } from "components/common"
import Container from "components/common/container/contianer"
import { ArabicLogo, EnglishLogo, IconLanguageSwitcher } from "components/svg"
import { getAppLanguage, useLanguage } from "hooks/useLanguage"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import styles from "./index.module.less"
import MobileNavbar from "./mobileNavbar"

const { Content, Footer } = Layout

function MobileHeader() {
  const { i18n } = useTranslation()
  const { changeAppLanguage, isCurrentLanguageEnglish } = useLanguage()
  const { label = "EN", key = "en" } = getAppLanguage()
  const { t, ready } = useTranslation()
  let invertedLabel = key === "en" ? "AR" : "EN"
  const mobileNavBarRef = useRef()

  return (
    <div>
      <div className={"breakout"} style={{ background: "#fff" }}>
        <Container>
          <Flex className={styles.mobileNav} justify="space-between">
            <Icon
              onClick={() => {
                mobileNavBarRef?.current?.setVisible(true)
              }}
              style={{ color: "black" }}
              icon={"IoMdMenu"}
              size="20px"
            />
            <Link to={"/"} style={{ lineHeight: "normal" }}>
              {isCurrentLanguageEnglish ? (
                <EnglishLogo width={92} height="auto" />
              ) : (
                <ArabicLogo width={92} height="auto" />
              )}
            </Link>
            <Flex gap="23px" className={styles.headerLink}>
              <Button
                type="link"
                icon={invertedLabel === "AR" ? null : "IconLanguageSwitcher"}
                iconProps={{
                  size: 20,
                }}
                text={t(invertedLabel)}
                onClick={changeAppLanguage}
              >
                {invertedLabel === "AR" && (
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <IconLanguageSwitcher size={20} />
                    <ArabicLogoInDroidArabicKufi width={35} height={20} style={{ marginBottom: 0 }} />
                  </div>
                )}
              </Button>
            </Flex>
          </Flex>
        </Container>
      </div>
      <MobileNavbar ref={mobileNavBarRef} />
    </div>
  )
}

export default MobileHeader
